import { motion } from "framer-motion";
import { Check, Home, Building2, Landmark } from "lucide-react";

const REASONS = [
  "Modern, well maintained equipment",
  "Skilled and experienced operators",
  "Committed to safety and quality",
  "Flexible, efficient and reliable service",
  "Proudly supporting local builders and concreters",
];

const SECTORS = [
  {
    icon: Home,
    title: "Residential",
    copy: "Slabs, footings, driveways and more.",
    testid: "sector-residential",
  },
  {
    icon: Building2,
    title: "Commercial",
    copy: "Shops, warehouses, offices and more.",
    testid: "sector-commercial",
  },
  {
    icon: Landmark,
    title: "Civil",
    copy: "Infrastructure, retaining walls, channels and more.",
    testid: "sector-civil",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 48 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  },
};

export default function WhyChoose() {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid gap-16 md:grid-cols-2 md:gap-12"
        >
          <div>
            <p className="mb-4 font-tech text-xs uppercase tracking-[0.3em] text-[#4D8DFF]">
              Why us
            </p>
            <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-5xl">
              Why choose
              <br />
              <span className="text-[#0052FF]">AP Pumping?</span>
            </h2>
            <ul className="mt-10 space-y-5" data-testid="why-choose-list">
              {REASONS.map((r) => (
                <li key={r} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0052FF]">
                    <Check className="h-4 w-4 text-white" strokeWidth={3} />
                  </span>
                  <span className="text-base text-slate-200 sm:text-lg">{r}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-4 font-tech text-xs uppercase tracking-[0.3em] text-[#4D8DFF]">
              Any project
            </p>
            <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-5xl">
              Equipped to handle
              <br />
              <span className="text-[#0052FF]">any project</span>
            </h2>
            <div className="mt-10 border-t border-white/10">
              {SECTORS.map((s) => (
                <div
                  key={s.title}
                  data-testid={s.testid}
                  className="group flex items-start gap-5 border-b border-white/10 py-7 transition-colors duration-300 hover:bg-white/[0.03]"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-[#0052FF] transition-transform duration-300 group-hover:scale-110">
                    <s.icon className="h-6 w-6 text-white" />
                  </span>
                  <div>
                    <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">
                      {s.title}
                    </h3>
                    <p className="mt-1 text-base text-slate-400">{s.copy}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}